import { useState } from "react";
import { Link } from "react-router-dom";
import { Menu, X } from "lucide-react"; // hamburger & close icons

export default function Navbar() {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <nav
      className="text-white p-4 flex items-center justify-between"
      style={{ backgroundColor: "#05952bff" }}
    >
      {/* Logo and Clinic Name */}
      <div className="flex items-center space-x-3">
        <img
          src="/images/logo.png"
          alt="Herbartz Logo"
          className="h-10 w-10 rounded-full shadow-md"
        />
        <h1 className="text-sm font-bold">
          Herbartz Ayurveda
        </h1>
      </div>

      {/* Desktop Links */}
      <div className="hidden md:flex space-x-6">
        <Link to="/" className="hover:underline">
          Home
        </Link>
        <Link to="/about" className="hover:underline">
          About
        </Link>
        <Link to="/services" className="hover:underline">
          Services
        </Link>
        <Link to="/products" className="hover:underline">
          Products
        </Link>
        <Link to="/contact" className="hover:underline">
          Contact
        </Link>
      </div>

      {/* Mobile Menu Button */}
      <div className="md:hidden">
        <button onClick={() => setIsOpen(!isOpen)}>
          {isOpen ? <X size={28} /> : <Menu size={28} />}
        </button>
      </div>

      {/* Mobile Links (Dropdown) */}
      {isOpen && (
        <div className="absolute top-16 left-0 w-full bg-green-700 text-white flex flex-col items-center space-y-4 py-6 md:hidden shadow-lg z-50">
          <Link to="/" onClick={() => setIsOpen(false)}>
            Home
          </Link>
          <Link to="/about" onClick={() => setIsOpen(false)}>
            About
          </Link>
          <Link to="/services" onClick={() => setIsOpen(false)}>
            Services
          </Link>
          <Link to="/products" onClick={() => setIsOpen(false)}>
            Products
          </Link>
          <Link to="/contact" onClick={() => setIsOpen(false)}>
            Contact
          </Link>
        </div>
      )}
    </nav>
  );
}